import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicBrandCosmeticBoxResponse } from './public-brand-cosmetic-box.response';

@jsonObject
export class PublicBrandCosmeticCollectionItemResponse {
  @jsonMember(String)
  public id!: Guid;

  @jsonMember(String)
  public name!: string;

  @jsonMember(String)
  public slug!: string;

  @jsonMember(MultimediaResponse)
  public featuredFile!: MultimediaResponse;

  @jsonArrayMember(PublicBrandCosmeticBoxResponse)
  public readonly boxes!: PublicBrandCosmeticBoxResponse[];
}
